// extracted by mini-css-extract-plugin
module.exports = {"modal":"jgp-3ixt9","title":"jgp-3a43V","icon":"jgp-2B0UY","closeButton":"jgp-DSEJ6","scrollBody":"jgp-TIw6h"};